const { ClientBillingContract } = require('bk-web-app');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.bk.clientBillingContract', deps)
  .directive('clientBillingContract', reactDirective => reactDirective(ClientBillingContract));
